import api from '../helpers';

export default {
  get: {
    key: 'fetchCompressors',
    query: (companyId) => {
      return api.get(`/api/compressors/${companyId}`, {
        headers: {
          'Content-Type': 'application/json',
        },
      });
    },
    mapper: ({ data }) => {
      return data.map((model) => model);
    },
  },
  getDeleted: {
    key: 'fetchDeletedCompressors',
    query: (companyId) => {
      return api.get(`/api/compressors/${companyId}/deleted`, {
        headers: {
          'Content-Type': 'application/json',
        },
      });
    },
    mapper: ({ data }) => data,
  },
  getTemplates: {
    key: 'fetchCompressorTemplates',
    query: (params = {}) => {
      const { page = 1, limit = 50, query = '' } = params;
      const queryParams = new URLSearchParams({
        page: page.toString(),
        limit: limit.toString(),
        ...(query && { query }),
      });

      return api.get(`/api/compressor-lookups?${queryParams}`, {
        headers: {
          'Content-Type': 'application/json',
        },
      });
    },
    mapper: ({ data }) => {
      return {
        templates: data.compressorLookups || [],
        total: data.total || 0,
        page: data.page || 1,
        totalPages: data.totalPages || 1,
      };
    },
  },
  create: {
    key: 'addCompressor',
    query: (data) => {
      return api.post('/api/compressor', {
        headers: {
          'Content-Type': 'application/json',
        },
        data,
      });
    },
  },
  edit: {
    key: 'editCompressor',
    query: (id, data) => {
      return api.put(`/api/compressor/${id}`, {
        headers: {
          'Content-Type': 'application/json',
        },
        data,
      });
    },
  },
  delete: {
    key: 'deleteCompressor',
    query: (id) => {
      return api.delete(`/api/compressor/${id}`, {
        headers: {
          'Content-Type': 'application/json',
        },
      });
    },
  },
  getDatasheet: {
    key: 'fetchCompressorDatasheet',
    query: (id) => {
      return api.get(`/api/compressor-lookups/${id}/datasheet`, {
        headers: {
          'Content-Type': 'application/pdf',
        },
        responseType: 'blob',
      });
    },
    mapper: ({ data, headers }) => {
      return {
        data,
        headers,
      };
    },
  },
  listRunningStateLogs: {
    key: 'fetchCompressorRunningStateLogs',
    query: (companyId, params = {}) => {
      const { offset = 0, limit = 100 } = params;
      const queryParams = new URLSearchParams({
        offset: offset.toString(),
        limit: limit.toString(),
      });
      return api.get(`/api/compressors/${companyId}/running-state-logs?${queryParams}`, {
        headers: { 'Content-Type': 'application/json' },
      });
    },
    mapper: ({ data }) => ({
      logs: data.logs || [],
      total: data.total || 0,
      offset: data.offset || 0,
      limit: data.limit || 0,
    }),
  },
  getCurrentRunningStateLog: {
    key: 'fetchCurrentCompressorRunningStateLog',
    query: (companyId) => {
      return api.get(`/api/compressors/${companyId}/running-state-logs/current`, {
        headers: { 'Content-Type': 'application/json' },
      });
    },
    mapper: ({ data }) => data,
  },
  // Backend auto-selects the latest snapshot and returns its US-DoE summary (or null
  // when the company has none). Drives the bulk system-parameters preview card.
  getLatestRunningStateSummary: {
    key: 'fetchLatestRunningStateSummary',
    query: (companyId) => {
      return api.get(`/api/compressors/${companyId}/running-state-logs/latest-summary`, {
        headers: { 'Content-Type': 'application/json' },
      });
    },
    mapper: ({ data }) => data,
  },
  getRunningStateLog: {
    key: 'fetchCompressorRunningStateLog',
    query: (companyId, id) => {
      return api.get(`/api/compressors/${companyId}/running-state-logs/${id}`, {
        headers: { 'Content-Type': 'application/json' },
      });
    },
    mapper: ({ data }) => data,
  },
  createRunningStateLog: {
    key: 'createCompressorRunningStateLog',
    query: (companyId, data) => {
      return api.post(`/api/compressors/${companyId}/running-state-logs`, {
        headers: { 'Content-Type': 'application/json' },
        data,
      });
    },
  },
};
